import React, { useState, useEffect} from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';
import TemplatePermissionItem from './TemplatePermissionItem';
import { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import Api from '../../services/Api'

const TemplatesPermissions = () => {
    
    const [isLoading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [users, setUsers] = useState({});
    const [message, setMessage] = useState();
    const [isSaving, setSaving] = useState(false);

    useEffect(() => {
        setLoading(true);
        getTemplates();
    }, []);

    const getTemplates = () => {
        Api.get(`/Settings/Templates?isCustom=true`)
        .then(res => res.data)
        .then(temp => {
            const users = temp.reduce((users, t) => {
                return {
                    ...users,
                    [t.id]: t.users.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);
            setTemplates(temp);
            setUsers(users);
            setLoading(false);
        })
        .catch(error => {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get templates settings from database: ' + error
            });
        });
    }

    const saveSettings = () => {
        setSaving(true);
        setMessage();

        Api.post(`/Settings/TemplatesUsers`, users)
        .then(res => res.data)
        .then(post => {
            if(post === 200) {
                setSaving(false);
                setMessage({
                    type: MessageBarType.success,
                    text: 'Settings have been saved.'
                });
            } else {
                setSaving(false);
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save settings: ' + post.message
                });
            }
        })
        .catch(error => {
            setSaving(false);
            console.log(error);
        });
    }

    const onSelectedUsers = (id, newUsers) => {
        const u = {
            ...users,
            [id]: newUsers
        }
        setUsers(u);
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const templatesItems = templates.map(t => 
                <TemplatePermissionItem 
                    key={t.id} 
                    name={t.name} 
                    location={t.location}
                    users={t.users}
                    onSelectedUsers={(users) => onSelectedUsers(t.id, users)} 
                />)
    
    const btn = isSaving
                ? <Spinner className='settings-btn' size={SpinnerSize.large} />
                : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    return (
        <div>
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container'>
                    {templatesItems}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}

export default TemplatesPermissions;



// WEBPACK FOOTER //
// ./src/components/Settings/TemplatesPermissions.js